import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer mt-auto">
      <div className="container py-5">
        <div className="row">
          {/* Mission Statement */}
          <div className="col-md-4 mb-4">
            <h5>Our Mission</h5>
            <p>
              Taking the Word of God into a lost & dying world and equipping the average Christian to become an above average soul-winner.
            </p>
          </div>

          {/* Contact Information */}
          <div className="col-md-4 mb-4">
            <h5>Contact Us</h5>
            <p className="mb-1">
              <strong>David Hardin</strong><br />
              Director<br />
              <a href="tel:770-906-7795">770-906-7795</a><br />
              <a href="mailto:d_hardin@theobp.com">d_hardin@theobp.com</a>
            </p>
          </div>

          {/* Sending Church */}
          <div className="col-md-4 mb-4">
            <h5>Sending Church</h5>
            <p className="mb-1">
              <strong>Hillcrest Baptist Church</strong><br />
              Acworth, Georgia<br />
              A ministry supported by churches of the<br />
              American Baptist Association
            </p>
          </div>
        </div>

        {/* Copyright and Feedback */}
        <div className="row mt-4">
          <div className="col-12 text-center">
            <p className="mb-0 small text-muted">
              &copy; {new Date().getFullYear()} The Outreach Bible Project. All rights reserved.
              {' | '}
              <a href="/privacy" className="text-muted">
                Privacy Policy
              </a>
              {process.env.REACT_APP_FEEDBACK_FORM_URL && (
                <>
                  {' | '}
                  <a
                    href={process.env.REACT_APP_FEEDBACK_FORM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-muted"
                  >
                    Send Feedback
                  </a>
                </>
              )}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
